import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { formatPercentage } from "@/common/utils/formatters";

export const updateEstablishmentCompanyDefaultValues = (establishmentCompany?: EstablishmentCompanyData) => ({
  ...establishmentCompany,
  product_categories: establishmentCompany?.company_product_categories?.map((category) => ({
    label: category.product_category.display_name,
    value: category.product_category.id,
  })),
  commercial_manager: {
    label: establishmentCompany?.commercial_manager?.full_name,
    value: establishmentCompany?.commercial_manager?.id,
  },
  commercial_manager_substitute: establishmentCompany?.commercial_manager_substitute ? {
    label: establishmentCompany?.commercial_manager_substitute?.full_name,
    value: establishmentCompany?.commercial_manager_substitute?.id,
  } : null,
  matrix_branch_attributes: {
    payment_advance_daily_interest: establishmentCompany?.matrix_branch_payment_advance_daily_interest
    ? formatPercentage(Number(establishmentCompany.matrix_branch_payment_advance_daily_interest))
    : undefined,
  },
  tow_service_available: establishmentCompany?.tow_service_available,
  ca_module_enabled: establishmentCompany?.ca_module_enabled,
  cm_module_enabled: establishmentCompany?.cm_module_enabled,
  tmais_module_enabled: establishmentCompany?.tmais_module_enabled,
  photos: establishmentCompany?.matrix_branch?.photos?.map((photo) => ({
    id: photo.id,
    file: photo.url,
  })),
});
